import type { StackProps } from '@chakra-ui/react'
import { Stack, Separator } from '@chakra-ui/react'
import type { FC } from 'react'

const Card: FC<StackProps> = ({ color = null, children, ...props }) => {
  const cardProps = {} as { borderTopColor?: string; borderTopWidth?: number }
  let borderColor = color
  // Handle both color family (e.g. "red") and specific color (e.g. "red.500") formats
  if (borderColor?.toString()?.includes('.')) {
    borderColor = borderColor?.toString().split('.')[0]
  }

  if (color) {
    cardProps.borderTopColor = `${borderColor}.400`
    cardProps.borderTopWidth = 5
  }

  return (
    <Stack
      bg="bg.panel"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="border.emphasized"
      borderRadius="6px"
      shadow="sm"
      {...cardProps}
      {...props}
      gap={0}
      separator={<Separator borderColor="border.emphasized" />}
    >
      {children}
    </Stack>
  )
}

export default Card
